import { Document, Page, pdf, Text, View } from "@react-pdf/renderer"
import { styles, TableCell } from "components"
import moment from "moment"
import { cellValuePdf, RowExportTypePdf } from "types"
import { convertNumber } from "utils"
import { SalesType } from "../../types"
import { statusMap } from "../vars"

type UseExportPdfByCard = {
  data: SalesType[]
  dateFilter: string
}

export const useExportPdfAllInvoice = ({
  data,
  dateFilter
}: UseExportPdfByCard) => {

  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "INVOICE ID#", key: "invoice_id", width: 25 },
    { header: "REF SO ID#", key: "ref_so_id", width: 25 },
    { header: "DATE", key: "date", width: 15 },
    { header: "CUSTOMER", key: "customer", width: 15 },
    { header: "STATUS APPROVAL", key: "status_approval", width: 15 },
    { header: "QTY. DELIVERED", key: "delivered", width: 15 },
    { header: "LOCATION", key: "location", width: 15 },
    { header: "SUBTOTAL", key: "subtotal", width: 15 },
    { header: "PAYMENT", key: "payment", width: 15 },
    { header: "BALANCE OWING", key: "balance_owing", width: 15 }
  ]

  function numberFormat(value: number): cellValuePdf {
    return {
      text: convertNumber(value).intoCurrency,
      style: {
        textAlign: "right",
        fontWeight: "bold"
      }
    }
  }

  const calculate = data.reduce(
    (acc, item) => {
      return {
        balance: acc.balance + item.balance_owing,
        payment: acc.payment + item.payment,
        subtotal: acc.subtotal + item.subtotal
      }
    },
    { balance: 0, payment: 0, subtotal: 0 }
  )

  const dataMap: RowExportTypePdf[] = data.map((item, index) => {
    return {
      no: (index + 1).toString(),
      invoice_id: item.trx_code,
      ref_so_id: item.sales_order.trx_code,
      date: moment(item.transaction_date).format("DD/MM/YYYY"),
      customer: item.customer.customer_name,
      status_approval: statusMap[item.approval_status],
      delivered: numberFormat(item.delivered_qty),
      location: item.location.location_name,
      subtotal: numberFormat(item.subtotal),
      payment: numberFormat(item.payment),
      balance_owing: numberFormat(item.balance_owing)
    }
  })

  return {
    handleExportPdf: () =>
      pdf(
        <PdfTemplate
          data={dataMap}
          column={columns}
          date={dateFilter}
          balance={calculate.balance}
          payment={calculate.payment}
          subtotal={calculate.subtotal}
        />
      )
        .toBlob()
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.download = `all-invoice-${dateFilter}.pdf`
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Gagal membuat PDF:", error)
        })
  }
}

function PdfTemplate({
  data,
  column,
  date,
  balance,
  payment,
  subtotal,
}: {
  data: RowExportTypePdf[]
  column: { header: string; key: string; width: number }[]
  date?: string
  balance: number
  payment: number
  subtotal: number
}) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>SALES</Text>
        <Text style={styles.title}>ALL INVOICE</Text>
        {date && <Text style={styles.date}>Date: {date}</Text>}
        <TableCell data={data} column={column} />
        <View
          style={{
            marginTop: 10,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end"
          }}>
          <View
            style={[
              styles.date,
              {
                display: "flex",
                flexDirection: "row",
                fontSize: 8
              }
            ]}>
            <Text>SUMMARY SUBTOTAL : </Text>
            <Text style={{ width: 50, textAlign: "right", paddingLeft: 2 }}>
              {convertNumber(subtotal).intoCurrency}
            </Text>
          </View>
          <View
            style={[
              styles.date,
              {
                display: "flex",
                flexDirection: "row",
                fontSize: 8
              }
            ]}>
            <Text>SUMMARY PAYMENT : </Text>
            <Text style={{ width: 50, textAlign: "right", paddingLeft: 2 }}>
              {convertNumber(payment).intoCurrency}
            </Text>
          </View>

          <View
            style={[
              styles.date,
              {
                display: "flex",
                flexDirection: "row",
                fontSize: 8
              }
            ]}>
            <Text>SUMMARY BALANCE : </Text>
            <Text style={{ width: 50, textAlign: "right", paddingLeft: 2 }}>
              {convertNumber(balance).intoCurrency}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  )
}
